<template>
  <base-modal
    :ref="modal.key"
    :show="open"
    :title="modalTitle"
    @on-confirm="saveSearch"
    @on-cancel="hide()"
    :okText="$t('Save')"
    :closeText="$t('Close')"
  >
    <v-row>
      <v-col>
        <v-text-field
          :label="$t('Save')"
          type="text"
          v-model="userSearch.name"
          maxlength="100"
          :hint="$t('Maximum100characters')"
          :error-messages="nameErrors"
          @input="$v.userSearch.name.$touch()"
          @blur="$v.userSearch.name.$touch()"
        ></v-text-field>
      </v-col>
    </v-row>
    <v-row>
      <v-col>
        <v-switch
          v-model="userSearch.isParameterizable"
          :label="$t('Parameterizable')"
        ></v-switch>
      </v-col>
    </v-row>
    <v-row>
      <v-col>
        <v-switch
          v-model="userSearch.addToExternalApps"
          :label="$t('ShowOnExternalApps')"
        ></v-switch>
      </v-col>
    </v-row>
  </base-modal>
</template>
<script>
import { required } from 'vuelidate/lib/validators';
import { validationMixin } from 'vuelidate';
import SearchService from '@/services/SearchService';
import UserSearch from '@/ecm/models/UserSearch';
import Utils from '@/ecm/common/Utils.js';

export default {
    name: 'UserSearchModal',
    created() {},
    data() {
        return {
            modal: {
                title: this.$t('SavedSearches'),
                key: 'userSearchModal',
            },
            userSearch: new UserSearch(),
            open: false,
            isNew: true,
        };
    },
    mixins: [validationMixin],
    validations: {
        userSearch: {
            name: { required },
        },
    },
    computed: {
        modalInstance() {
            return this.$refs[this.modal.key];
        },
        modalTitle() {
            return (
                this.modal.title +
                (this.userSearch.name ? ` - ${this.userSearch.name}` : '')
            );
        },
        nameErrors() {
            const errors = [];
            if (!this.$v.userSearch.name.$dirty) return errors;
            !this.$v.userSearch.name.required &&
                errors.push(this.$t('RequiredField'));

            if (this.userSearch.name.length == 100) {
                errors.push(this.$t('Maximum100characters'));
            }

            return errors;
        },
    },
    methods: {
        saveSearch() {
            this.$v.$touch();

            if (this.$v.$invalid) {
                return;
            }

            this.modalInstance.progress(true);

            SearchService.saveUserSearch(this.userSearch.toDto())
                .then((userSearchId) => {
                    if (this.isNew) {
                        Utils.toast.success(
                            this.$t('UserSearch') + ' ' + this.$t('CreatedSuccessfullyFem')
                        );
                    } else {
                        Utils.toast.success(
                            this.$t('UserSearch') + ' ' + this.$t('UpdatedSuccessfullyFem')
                        );
                    }
                    this.userSearch.id = userSearchId;
                    this.$store.dispatch('account/getUserSavedSearches');
                    this.hide();
                })
                .catch(() => {
                    // error
                })
                .then(() => {
                    //always
                    this.modalInstance.progress(false);
                });
        },
        edit(userSearch) {
            this.userSearch = userSearch;
            if (this.userSearch.id == 0) {
                this.isNew = true;
            } else {
                this.isNew = false;
            }
            this.show();
        },
        show() {
            this.open = true;
        },
        hide() {
            this.isNew = true;
            this.open = false;
        },
    },
};
</script>
